/* eslint-disable max-len */

import createMuiTheme, { Theme } from '@material-ui/core/styles/createMuiTheme';
import { spacingUnit } from './constants';
import { overrides } from './theme-overrides';

// our custom palette
declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    icon: Palette['primary'];
    danger: Palette['primary'];
  }

  interface PaletteOptions {
    icon: Palette['primary'];
    danger: Palette['primary'];
  }
}

// BTCS custom palette
declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    icon: Palette['primary'];
    danger: Palette['primary'];
  }

  interface PaletteOptions {
    icon: Palette['primary'];
    danger: Palette['primary'];
  }
}

// base theme
export const baseMUIThemeInternal: Theme = createMuiTheme({
  shape: {
    borderRadius: spacingUnit * 0.5,
  },

  spacing: spacingUnit,

  shadows: [
    'none',
    '0 0.9px 1.8px -10px rgba(0, 0, 0, 0.016), 0 2.8px 5px -10px rgba(0, 0, 0, 0.021), 0 7.1px 12.1px -10px rgba(0, 0, 0, 0.028), 0 21px 40px -10px rgba(0, 0, 0, 0.05)',
    '0 -1px 2px rgba(0,0,0,.025),0 0.9px 1.8px -10px rgba(0, 0, 0, 0.016), 0 2.8px 5px -10px rgba(0, 0, 0, 0.021), 0 7.1px 12.1px -10px rgba(0, 0, 0, 0.028), 0 21px 40px -10px rgba(0, 0, 0, 0.05)',
    '0 1.3px 1.8px -9px rgba(0, 0, 0, 0.026), 0 4.2px 5px -9px rgba(0, 0, 0, 0.034), 0 10.4px 12.1px -9px rgba(0, 0, 0, 0.044), 0 31px 40px -9px rgba(0, 0, 0, 0.08)',
    '0 1.6px 2.3px -8px rgba(0, 0, 0, 0.029), 0 5.2px 6.3px -8px rgba(0, 0, 0, 0.038), 0 13.1px 15.1px -8px rgba(0, 0, 0, 0.05), 0 39px 50px -8px rgba(0, 0, 0, 0.09)',
    '0 2px 2.6px -6px rgba(0, 0, 0, 0.032), 0 6.4px 7.3px -6px rgba(0, 0, 0, 0.042), 0 16.1px 17.5px -6px rgba(0, 0, 0, 0.055), 0 48px 58px -6px rgba(0, 0, 0, 0.1)',
    '0 2.5px 3.1px -6px rgba(0, 0, 0, 0.032), 0 8px 8.5px -6px rgba(0, 0, 0, 0.042), 0 20.2px 20.5px -6px rgba(0, 0, 0, 0.058), 0 60px 68px -6px rgba(0, 0, 0, 0.1)',
    '',
    '0 3.1px 3.7px -5px rgba(0, 0, 0, 0.032), 0 9.9px 10.3px -5px rgba(0, 0, 0, 0.044), 0 24.9px 24.7px -5px rgba(0, 0, 0, 0.058), 0 74px 82px -5px rgba(0, 0, 0, 0.1)',
    '0 3.7px 5.2px -2px rgba(0, 0, 0, 0.032), 0 11.9px 14.3px -2px rgba(0, 0, 0, 0.046), 0 29.9px 34.4px -2px rgba(0, 0, 0, 0.061), 0 89px 114px -2px rgba(0, 0, 0, 0.1)',
    '',
    '',
    '0 4.1px 6.6px rgba(0, 0, 0, 0.032), 0 13.1px 18.3px rgba(0, 0, 0, 0.048), 0 33px 44px rgba(0, 0, 0, 0.061), 0 98px 146px rgba(0, 0, 0, 0.1)',
    '',
    '',
    '',
    '0 4.7px 8.2px rgba(0, 0, 0, 0.032), 0 15px 22.7px rgba(0, 0, 0, 0.048), 0 37.7px 54.6px rgba(0, 0, 0, 0.055), 0 112px 181px rgba(0, 0, 0, 0.1)',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  props: {
    MuiButtonBase: {
      disableRipple: true, // No more ripple, on the whole application 💣!
    },
    MuiFilledInput: {
      disableUnderline: true,
    },
  },

});

// overrides
baseMUIThemeInternal.overrides = overrides(baseMUIThemeInternal);

export const baseMUITheme = baseMUIThemeInternal;
